/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Tue Jan 30 2024
 **/

import styled from "@emotion/styled";

import { Column, Typography } from "@/frameworks/designStuff/components";

// DocumentViewer
export const ViewerWrap = styled(Column)`
	width: 100vw;
	height: 100vh;
	position: relative;
	background-color: ${({ theme }) => theme.colors.neutral_80_90};
	backdrop-filter: blur(10px);

	overflow: hidden;

	&.minimize {
		width: 70vw;
		height: 70vh;
		min-width: 567px;
	}
`;

export const Body = styled(Column)`
	width: 100%;
	height: 100%;
`;

// Image, File Viewer
export const FileViewerMobileWrap = styled(Column)`
	padding-top: 60px;
	width: 100%;
	height: 100%;
	background-color: ${({ theme }) => theme.colors.primary_70_100};
	& > .react-transform-wrapper {
		height: 100%;
		width: 100%;
		overflow: hidden;
	}
`;

export const LoadingFile = styled(Typography)`
	position: absolute;
	top: 60px;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 1;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: ${({ theme }) => theme.colors.primary_70_100};

	&::after {
		content: "";
		display: inline-block;
		animation: dots 1.5s steps(4, end) infinite;
	}

	@keyframes dots {
		0% {
			content: "";
		}
		25% {
			content: ".";
		}
		50% {
			content: "..";
		}
		75% {
			content: "...";
		}
		100% {
			content: "";
		}
	}
`;
